import React, { useEffect } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RenderPurchaseOrderDetail } from '../PurchaseOrderDetails/RenderPurchaseOrderDetail';
import { RenderOrderDetail } from '../PurchaseOrderDetails/RenderOrderDetail';
import { RenderColourSection } from '../PurchaseOrderDetails/RenderColourSection/index';
import { RenderShippingDetails } from '../PurchaseOrderDetails/RenderShippingDetails';
import { RenderTermsAndCondition } from '../PurchaseOrderDetails/RenderTermsAndCondition';
import { RenderCompanyDetails } from '../PurchaseOrderDetails/RenderCompanyDetails';
import { RenderGrandTotal } from '../PurchaseOrderDetails/RenderGrandTotal';
import { RenderSupplierFactoryDetails } from '../PurchaseOrderDetails/RenderSupplierFactoryDetails';
import { checkArray } from '../../../../Components/helper';
import { Section, ElementTemplate } from '../TemplateComponent';
import { commonPath } from '../fieldPath';
import { usePurchaseOrderState } from '../PurchaseOrderContext/index';
import * as action from '../Store/PurchaseOrder.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';

function PreviewModal({ onOpen, toggle, isPublicPoPage }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('common');
  const history = useHistory();
  const {
    purchaseOrderData: { purchaseOrderDetails, devorderData, previewDevData },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);

  if (localStorage.getItem('redirectionToPO')) {
    localStorage.removeItem('redirectionToPO');
  }

  const searchParams = new URLSearchParams(location?.search);

  const dId = searchParams.get('dId');
  const pId = searchParams.get('pId');
  const sId = searchParams.get('supplierId');

  const {
    controlState: {
      confirmModalType,
      confirmModalState,
      confirmModalMessage,
      confirmModalSecondMessage,
      confirmModalThirdMessage,
      confirmModalShowthirdMsg,
      confirmModalCommentMsg,
      confirmModalTitle,
      confirmModalCommentState,
      confirmModalLoading,
    },
    purchaseOrderState: { status, poOrderNo, supplierId },
    setPurchaseOrderState,
    previewData,
    disableConditions,
    callDevorderApiFn,
    callDevorderPoidApiFn,
    callUserIdBasedApiFn,
    fromPreview,
    isPublicPoPage: isPublicPoPageState,
    initialSetting,
    setControlState,
    oldInitialSetting,
    setOldState,
  } = usePurchaseOrderState();

  useEffect(() => {
    if (!isEmpty(purchaseOrderDetails)) {
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        templateJsonSchema: purchaseOrderDetails?.templateJsonSchema,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrderDetails]);

  useEffect(() => {
    if (isPublicPoPage) {
      const devOrderId = dId;
      const poId = pId;
      if (!sId) {
        dispatch(action.poPublicData(devOrderId));
      }
      dispatch(action.poPublicPurchaseData(devOrderId, poId));
      if (sId) {
        dispatch(action.poPublicDevData({ devOrderId: dId }));
      }
    }
  }, [isPublicPoPage, dispatch]);

  const handleConfirmModal = (type) => {
    let message = '';
    let secondMessage = '';
    let thirdMessage = '';
    let title = '';
    let showThirdMsg = false;
    let isCommentOn = false;
    const deleteConfirmationMessage = t('PREVIEW_MODAL.CONTINUE_CONFIRMATION_MESSAGE');
    switch (type) {
      case 'back':
        message = t('PREVIEW_MODAL.UNSAVE_CHANGE_CONTINUE_MESSAGE');
        secondMessage = t('PREVIEW_MODAL.REQUIRED_FIELD_MESSAGE');
        thirdMessage = deleteConfirmationMessage;
        title = t('PREVIEW_MODAL.UNSAVE_MESSAGE');
        showThirdMsg = true;
        break;
      case 'revise':
        message = t('PREVIEW_MODAL.REVISE_PURCHASE_ORDER_MESSAGE');
        secondMessage = deleteConfirmationMessage;
        title = t('PREVIEW_MODAL.REVISE_PURCHASE_ORDER');
        break;
      case 'cancel':
        message = t('PREVIEW_MODAL.CANCELED_PURCHASE_ORDER_MESSAGE');
        secondMessage = deleteConfirmationMessage;
        title = t('PREVIEW_MODAL.CANCEL_PURCHASE_ORDER');
        break;
      case 'Reject':
      case 'Approve':
        message = `${t('PREVIEW_MODAL.CONFIRM_MESSAGE')} ${type === 'Reject' ? t('PREVIEW_MODAL.REJECT') : t('PREVIEW_MODAL.APPROVE')} ${t(
          'PREVIEW_MODAL.PURCHASE_ORDER',
        )}`;
        secondMessage = t('PREVIEW_MODAL.ACTION_APPROVE_REJECT_MESSAGE');
        title = `${type === 'Reject' ? t('PREVIEW_MODAL.REJECT') : t('PREVIEW_MODAL.APPROVE')} ${t('PREVIEW_MODAL.PURCHASE_ORDER')}`;
        isCommentOn = true;
        break;
      case 'ApproveAfterCancle':
        message = t('PREVIEW_MODAL.PURCHASE_APPROVE_MESSAGE');
        secondMessage = t('PREVIEW_MODAL.PURCHASE_CANCELLED_MESSAGE');
        title = t('PREVIEW_MODAL.PURCHASE_ORDER_MESSAGE');
        isCommentOn = true;
        break;
      case 'RejectAfterCancle':
        message = t('PREVIEW_MODAL.CANCEL_PURCHASE_ORDER_MESSAGE');
        secondMessage = t('PREVIEW_MODAL.CANCEL_ACTION_PURCHASE_ORDER_MESSAGE');
        title = t('PREVIEW_MODAL.CANCEL_PURCHASE_ORDER');
        isCommentOn = true;
        break;
      default:
        break;
    }
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalType: type,
      confirmModalState: true,
      confirmModalMessage: message,
      confirmModalSecondMessage: secondMessage,
      confirmModalThirdMessage: thirdMessage,
      confirmModalShowthirdMsg: showThirdMsg,
      confirmModalTitle: title,
      confirmModalCommentState: isCommentOn,
    }));
  };

  const redirectPurchaseOrderListPage = () => {
    history.push(`/development-order/${devorderData?._id || dId}/purchase-orders`);
    setOldState((...oldStates) => ({
      ...oldStates,
      ...oldInitialSetting,
    }));
  };

  const handleToggle = () => {
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalType: '',
      confirmModalState: false,
      confirmModalMessage: '',
      confirmModalSecondMessage: '',
      confirmModalThirdMessage: '',
      confirmModalShowthirdMsg: false,
      confirmModalTitle: '',
      confirmModalCommentState: false,
      confirmModalCommentMsg: '',
      confirmModalLoading: false,
    }));
  };

  const handleBackAction = async () => {
    await dispatch(action.emptyData());
    redirectPurchaseOrderListPage();
  };

  const handleReviseOrCancelAction = async () => {
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalLoading: true,
    }));
    const obj = {
      devOrderId: devorderData?._id || dId,
      poId: pId,
    };
    const reqObj = {
      comment: null,
      poOrderNo,
      status: confirmModalType === 'cancel' ? 'canceled' : 'revised',
      supplierId,
    };
    const res = await dispatch(action.revisePo(obj, reqObj));
    if (res) {
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        status: reqObj.status,
      }));
      handleToggle();
      if (!sId) {
        await dispatch(action.poPublicData(dId));
      }
      await dispatch(action.poPublicPurchaseData(dId, pId));
      if (sId) {
        await dispatch(action.poPublicDevData({ devOrderId: dId }));
      }
      if (!isPublicPoPage) {
        await callDevorderApiFn();
        await callDevorderPoidApiFn();
        await callUserIdBasedApiFn();
      }
    }
  };

  const handleRejectOrApproveAction = async () => {
    setPurchaseOrderState((prevState) => ({
      ...prevState,
      ...initialSetting,
    }));
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalLoading: true,
    }));
    const data = {
      devOrderId: dId,
      createPoId: pId,
      status: confirmModalType === 'ApproveAfterCancle' ? 'Approve' : confirmModalType,
      comment: confirmModalCommentMsg,
      supplierId,
      PoNo: poOrderNo,
      devOrderDetails: {
        brand: devorderData?.brandId,
        catOne: devorderData?.catOneId,
        catTwo: devorderData?.catTwoId,
      },
    };
    const response = await dispatch(action.rejectApprove(data, t));
    if (response) {
      handleToggle();
      if (!sId) {
        await dispatch(action.poPublicData(dId));
      }
      await dispatch(action.poPublicPurchaseData(dId, pId));
      if (sId) {
        await dispatch(action.poPublicDevData({ devOrderId: dId }));
      }
      if (!isPublicPoPage) {
        await callDevorderApiFn();
        await callDevorderPoidApiFn();
        await callUserIdBasedApiFn();
      }
    }
  };

  const handleRejectAfterCancelAction = async () => {
    setPurchaseOrderState((prevState) => ({
      ...prevState,
      ...initialSetting,
    }));
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalLoading: true,
    }));
    const object = {
      devOrderId: devorderData?._id || dId,
      createPoId: pId,
      status: 'canceled',
      comment: confirmModalCommentMsg,
      supplierId,
      PoNo: poOrderNo,
      devOrderDetails: {
        brand: devorderData?.brandId,
        catOne: devorderData?.catOneId,
        catTwo: devorderData?.catTwoId,
      },
    };
    const results = await dispatch(action.rejectApprove(object, t));
    if (results) {
      handleToggle();
      if (!isPublicPoPage) {
        await callDevorderApiFn();
        await callDevorderPoidApiFn();
        await callUserIdBasedApiFn();
      }
    }
  };

  const onConfirmPurchase = async () => {
    switch (confirmModalType) {
      case 'back':
        await handleBackAction();

        break;
      case 'revise':
      case 'cancel':
        await handleReviseOrCancelAction();

        break;
      case 'Reject':
      case 'Approve':
      case 'ApproveAfterCancle':
        await handleRejectOrApproveAction();

        break;
      case 'RejectAfterCancle':
        await handleRejectAfterCancelAction();

        break;
      default:
        break;
    }
  };

  return (
    <>
      {!isPublicPoPage ? (
        <Modal
          className="relative-width-modal custom-modal modal-medium-4x supplier-overview-modal color-way-modal"
          size="lg"
          show={onOpen}
          onHide={toggle}
          backdrop="static"
          centered
        >
          <Modal.Header>
            <Modal.Title>{t('PREVIEW_MODAL.PURCHASE_ORDER_PREVIEW')}</Modal.Title>
            <span onClick={toggle} className="icon-close cursor-pointer" />
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <RenderPurchaseOrderDetail />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RenderOrderDetail />
              </Col>
            </Row>
            {checkArray(previewData?.templateJsonSchema) &&
              previewData?.templateJsonSchema.map((temp, i) => {
                return (
                  <>
                    <Row>
                      <Col lg={12}>{temp?.key === 'Shipping_Details' && <RenderShippingDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row className="pt-1">
                      <Col lg={12}>{temp?.key === 'Terms_conditions' && <RenderTermsAndCondition data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>{temp?.key === 'Company_Details' && <RenderCompanyDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        {temp?.key === 'Section' && (
                          <Section prop={temp}>
                            {temp?.columns.map((column, colIndex) => {
                              return (
                                <Row key={colIndex}>
                                  {column.map((col, colChildIndex) => {
                                    return (
                                      <Col lg={6} key={colChildIndex}>
                                        <div>
                                          <ElementTemplate
                                            {...col}
                                            keys={col?.key}
                                            pIndex={i}
                                            path={
                                              col?.key === 'Check_Boxes'
                                                ? commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS_CHECKBOX
                                                : commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS
                                            }
                                            disable={!col?.enable || disableConditions() || fromPreview || isPublicPoPageState}
                                          />
                                        </div>
                                      </Col>
                                    );
                                  })}
                                </Row>
                              );
                            })}
                          </Section>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-1">
                      <Col lg={12}>{temp?.key === 'Grand_Total' && <RenderGrandTotal />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>{temp?.key === 'A_F_Details' && <RenderSupplierFactoryDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        {temp?.key === 'Ratio_Pack' && (
                          <RenderColourSection data={temp} parentI={i} totalData={previewData} fromPreview isPublicPoPageState previewData={previewData} />
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
          </Modal.Body>
        </Modal>
      ) : (
        <>
          <div>
            <div className="page-title-filter sticky">
              <div className="title-container">
                <h4 className="title">{previewDevData?.number ? previewDevData?.number : 'PUBLIC PO'}</h4>
              </div>
              <div className="search-filter">
                {status === 'Active' && (
                  <>
                    <button className="btn btn-po btn-red" type="button" onClick={() => handleConfirmModal('Reject')}>
                      {t('PREVIEW_MODAL.REJECT_PO')}
                    </button>
                    <button className="btn btn-po btn-green" type="button" onClick={() => handleConfirmModal('Approve')}>
                      {t('PREVIEW_MODAL.CONFIRM_PO')}
                    </button>
                  </>
                )}
                {status === 'Cancel Request' && !isSupplierLoggedIn && (
                  <>
                    <button className="btn btn-po btn-red" type="button" onClick={() => handleConfirmModal('ApproveAfterCancle')}>
                      {t('PREVIEW_MODAL.REJECT_CANCEL')}
                    </button>
                    <button className="btn btn-po btn-green" type="button" onClick={() => handleConfirmModal('RejectAfterCancle')}>
                      {t('PREVIEW_MODAL.CONFIRM_CANCEL')}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="container">
            <Row>
              <Col lg={12}>
                <RenderPurchaseOrderDetail />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RenderOrderDetail />
              </Col>
            </Row>
            {checkArray(previewData?.templateJsonSchema) &&
              previewData?.templateJsonSchema.map((temp, i) => {
                return (
                  <>
                    <Row>
                      <Col lg={12}>{temp?.key === 'Shipping_Details' && <RenderShippingDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row className="pt-1">
                      <Col lg={12}>{temp?.key === 'Terms_conditions' && <RenderTermsAndCondition data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>{temp?.key === 'Company_Details' && <RenderCompanyDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        {temp?.key === 'Section' && (
                          <Section prop={temp}>
                            {temp?.columns.map((column, colIndex) => {
                              return (
                                <Row key={colIndex}>
                                  {column.map((col, colChildIndex) => {
                                    return (
                                      <Col lg={6} key={colChildIndex}>
                                        <div>
                                          <ElementTemplate
                                            {...col}
                                            keys={col?.key}
                                            pIndex={i}
                                            path={
                                              col?.key === 'Check_Boxes'
                                                ? commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS_CHECKBOX
                                                : commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS
                                            }
                                            disable={!col?.enable || disableConditions() || fromPreview || isPublicPoPageState}
                                          />
                                        </div>
                                      </Col>
                                    );
                                  })}
                                </Row>
                              );
                            })}
                          </Section>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-1">
                      <Col lg={12}>{temp?.key === 'Grand_Total' && <RenderGrandTotal />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>{temp?.key === 'A_F_Details' && <RenderSupplierFactoryDetails data={temp} pIndex={i} />}</Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        {temp?.key === 'Ratio_Pack' && (
                          <RenderColourSection data={temp} parentI={i} totalData={previewData} fromPreview isPublicPoPageState previewData={previewData} />
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
          </div>
        </>
      )}
      {confirmModalState && (
        <ConfirmationPopup
          onOpen={confirmModalState}
          onConfirm={onConfirmPurchase}
          loading={confirmModalLoading}
          title={confirmModalTitle}
          message={confirmModalMessage}
          toggle={handleToggle}
          secondMessage={confirmModalSecondMessage}
          showThirdMsg={confirmModalShowthirdMsg}
          thirdMessage={confirmModalThirdMessage}
          commentText={(e) =>
            setControlState((prevState) => ({
              ...prevState,
              confirmModalCommentMsg: e.target.value,
            }))
          }
          isCommentOn={confirmModalCommentState}
        />
      )}
    </>
  );
}

export default PreviewModal;
